import React, { useContext, useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { IconButton } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ImagenPrueba from "../../images/imagen_card_prueba.jpeg";
import img_default from "../../images/img_default.png";
import "../../css/empresa_uno/visitas.css";

import CloseIcon from '@mui/icons-material/Close';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { WhatsApp } from "@mui/icons-material";
import { ImagenesGlobal } from "../global/ImagenesGlobal";

export const ModalViewProduct = ({
	product,
	allProducts = [], // <--- Recibimos todos los productos
	onSelectProduct, // <--- Callback para actualizar el producto en el padre
	discountPercentage = null,
	loadImageS,
	itsCompany = true,
	convertPrice = (() => { })
}) => {
	const [index, setIndex] = useState(0);

	if (product == false || !product) return;

	const hasDiscount = discountPercentage > 0;
	const priceNum = parseFloat(product.sale_price || "0");
	const finalPrice = hasDiscount ? (priceNum * (1 - discountPercentage / 100)).toFixed(2) : priceNum.toFixed(2);

	// ---------------------------------------
	// 1) Lista de productos RELACIONADOS (solo misma categoría)
	// ---------------------------------------
	const relatedSameCategory = allProducts.filter(
		(p) => p.category_name === product.category_name && p.code !== product.code // opcional: excluir el mismo producto
	);

	// ---------------------------------------
	// 2) Lista de productos RELACIONADOS (misma categoría y marca)
	// ---------------------------------------
	const relatedCategoryBrand = allProducts.filter((p) => {
		const sameCategory = p.category_name?.toLowerCase().trim() === product.category_name?.toLowerCase().trim();

		const sameBrand = p.brand_name?.toLowerCase().trim() === product.brand_name?.toLowerCase().trim();

		return (sameCategory || sameBrand) && p.code !== product.code;
	});

	// Para truncar texto muy largo
	const truncateText = (text = "", maxLength = 15) => {
		return text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
	};

	const handleCardClick = (prodRelacionado) => {
		onSelectProduct(prodRelacionado);
		// NOTA: No cerramos el modal, así se refresca la info arriba
	};


	const nextImage = () => {
		setIndex((prevIndex) => (prevIndex + 1) % product?.img_list.length);
	};

	const prevImage = () => {
		setIndex((prevIndex) => (prevIndex - 1 + product?.img_list.length) % product?.img_list.length);
	};


	return (
		<>
			<div className="content-product">
				<div className="slider-products" style={{ position: 'relative' }}>
					<ul key={product?.code} style={{
						display: 'flex',
						transition: 'transform 0.5s ease',
						transform: `translateX(-${index * 100}%)`,
						padding: 0,
						margin: 0,
						listStyle: 'none',
						width: `${product?.img_list.length * 100}%`,
						alignContent: 'center'
					}}>
						{product && (product.img_list ?? []).map((imgSrc, i) => (
							<li key={i} style={{ width: '100%', flexShrink: 0, display: 'flex', alignItems: 'center' }}>
								<ImagenesGlobal url={imgSrc ?? null} type={'picture'} style={{ width: '100%', display: 'block' }} loadImageS={loadImageS} />
							</li>
						))}
					</ul>

					<div className="control-list">
						<IconButton className="icons-modal-p" onClick={prevImage} sx={{ height: 'calc(5px + var(--size-icon))', width: 'calc(5px + var(--size-icon))' }}>
							<NavigateBeforeIcon sx={{ color: '#fff' }} style={{ fontSize: 'var(--size-icon)' }} />
						</IconButton>

						<IconButton className="icons-modal-p" onClick={nextImage} sx={{ height: 'calc(5px + var(--size-icon))', width: 'calc(5px + var(--size-icon))' }}>
							<NavigateNextIcon sx={{ color: '#fff' }} style={{ fontSize: 'var(--size-icon)' }} />
						</IconButton>
					</div>
				</div>

				<div className="product-informacion">
					<h2 style={{ fontSize: 'clamp(1rem, 2.5vw, 1.7rem)', fontWeight: 500, color: itsCompany ? 'var(--theme-visit)' : 'var(--empresa-color)', width: '100%', borderBottom: `2px solid var(--theme-visit)` }}>{product?.product_name ?? "Producto sin nombre"}</h2>

					<ul style={{ borderBottom: '2px solid #000', fontSize: 'clamp(0.6rem, 1.5vw, 1rem)' }}>
						<li>Codigo: {product?.code ?? "Sin Codigo..."}</li>
						<li>Marca: {product?.brand_name ?? "Sin Marca..."}</li>
						<li>Descripción: {product?.category_name ?? "Sin Descripción..."}</li>
					</ul>

					<ul style={{ fontSize: 'clamp(0.6rem, 1.5vw, 1rem)' }}>
						{Object.entries(product.description || {}).map(([key, val], position) => (
							position <= 12 ? (<li key={key} className={position % 2 === 0 ? "txt-plomo" : ""}>
								{key}: {val || "Sin valor"}
							</li>) : null
						))}
					</ul>

					<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							{
								discountPercentage > 0 ? (
									<>
										<span title="price" style={{ fontSize: '13px', color: '#999', textDecoration: 'line-through' }}>
											{convertPrice(product?.sale_price, product?.currency)}
										</span>
										<span title="price" style={{ fontSize: '16px', color: '#008000' }}>
											{convertPrice(finalPrice, product?.currency)}
										</span>
									</>
								) : (
									<span title="price" style={{ fontSize: 'clamp(0.6rem, 1.5vw, 1rem)', color: '#008000' }}>
										{convertPrice(product?.sale_price, product?.currency)}
									</span>
								)
							}

						</div>

						<span title="locality" style={{ fontSize: 'clamp(0.6rem, 1.5vw, 1rem)', color: 'var(--theme-visit)' }}>
							{product?.locality}
						</span>
					</div>

					<a
						href={`https://wa.me/${product?.reference}?text=Hola!%20le%20escribo%20de%20hosming,%20me%20interesa%20el%20producto%20*%22${product?.product_name ?? "Sin%20Nombre..."}%22*,%20el%20codigo%20es%20*${product?.code ?? "Sin%20codigo..."}*,%20de%20la%20marca%20*${product?.brand_name}*`}
						target="_blank"
						style={{ borderRadius: '10px', backgroundColor: itsCompany ? 'var(--theme-visit)' : 'var(--empresa-color)', padding: '10px', color: '#fff', fontSize: 'clamp(0.6rem, 1.6vw, 1.3rem)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', gap: '5px' }}>
						<WhatsApp />
						Enviar Mensaje
					</a>
				</div>
			</div>
			<hr></hr>

			<div className="related-products-cont">
				<h3 className="related-products-title" style={{ color: itsCompany ? 'var(--theme-visit)' : 'var(--empresa-color)' }}>Productos relacionados</h3>
				{/* Botones: productos de la misma categoría */}
				<div className="related-list">
					{relatedSameCategory.map((relProd, idx) => (
						idx <= 7 ? (
							<button
								key={idx}
								className="related-product-button"
								onClick={() => handleCardClick(relProd)}
								style={{ fontSize: 'clamp(0.6rem, 1.5vw, 1rem)' }}
							>
								{truncateText(relProd.product_name, 30)}
							</button>
						) : null
					))}
				</div>
			</div>

			<div className="related-products-images">
				{relatedCategoryBrand.length === 0 ? (
					<p style={{ margin: "10px 0" }}>No hay productos de la misma categoría y marca.</p>
				) : (
					relatedCategoryBrand.map((relProd, idx) => {
						return (
							<div key={idx} className="related-product-card" onClick={() => handleCardClick(relProd)}>
								<ImagenesGlobal url={relProd.img_list?.[0]} type={'picture'} className="related-product-image" loadImageS={loadImageS} />

								<div className="related-product-info">
									<span className="related-product-name">
										{truncateText(relProd.product_name, 15)}
									</span>

									{hasDiscount ? (
										<>
											<div style={{ display: "flex", flexDirection: "row" }}>
												<span
													style={{
														textDecoration: "line-through",
														color: "#999",
														fontSize: "0.75rem",
													}}>
													{convertPrice(relProd.sale_price, relProd?.currency)}
												</span>
												<span className="related-product-price" style={{ color: '#008000' }}>
													{convertPrice(
														parseFloat(relProd.sale_price) *
														(1 - discountPercentage / 100)
														, relProd?.currency)}
												</span>
											</div>
										</>
									) : (
										<span className="related-product-price" style={{ color: '#008000' }}>
											{convertPrice(relProd.sale_price, relProd?.currency)}
										</span>
									)}
								</div>
							</div>
						);
					})
				)}
			</div>
		</>
	);
};
